import {useContext} from "react";
import {ToastContext} from "../context/ToastContext";

export function useToast() : {showToast : (severity: "success" | "warn" | "error", summary: string, detail: string) => void, useConfirmPopup : (message: string) => Promise<boolean>}{
    const toastHelpers = useContext(ToastContext);
    return toastHelpers;
}